import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";

/**
 * Props for `TextPanels`.
 */
export type TextPanelsProps = SliceComponentProps<Content.TextPanelsSlice>;

/**
 * Component for "TextPanels" Slices.
 */
const TextPanels: FC<TextPanelsProps> = ({ slice }) => {

  const colSettings = slice.primary.column_setting === true ? "col-span-12 md:col-span-4" : "col-span-12 md:col-span-6";
  
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`px-4 md:px-8 lg:px-12 xl:px-0 bg-lightgrey font-fellix py-16 ${slice.primary.multiple_rows === "Top Row" ? "py-16" : slice.primary.multiple_rows === "Bottom Row" ? "py-16" : "py-8"}`}
    >
      <div className="max-w-[880px] mx-auto grid grid-cols-12 gap-6 h-full">
            {slice.primary.content.map((item:any, index: number)=>{
              if(item.content[0] && item.content[0].text !== "blank") {
                return (
                  <div className={colSettings} key={index}>
                    <div className="bg-white p-6 h-full prose prose-p:text-[18px] prose-p:leading-[26px] prose-a:text-blue-500 prose-a:no-underline prose-a:hover:underline prose-h4:font-semibold prose-h4:text-[28px] prose-h4:leading-[36px] prose-h4:mb-[36px]">
                      <PrismicRichText field={item.content}/>
                    </div>
                  </div>
                )
              }
              else {
                return (
                  <div className={colSettings} key={index}>
                  </div>
                )
              }
            })}
            </div>
    </section>
  );
};

export default TextPanels;

